import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { RecaptchaService } from './recaptcha.service';

@Component({
  selector: 'app-recaptcha-v2-fallback',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="recaptcha-v2-fallback">
      <p class="hint">Additional verification needed — please confirm you're not a robot.</p>
      <div #container></div>
    </div>
  `,
  styles: [
    `
      .recaptcha-v2-fallback {
        margin: 1rem 0;
      }
      .hint {
        margin-bottom: 0.5rem;
        color: var(--mat-sys-on-surface-variant, #555);
        font-size: 0.875rem;
      }
    `,
  ],
})
export class RecaptchaV2FallbackComponent implements AfterViewInit {
  @ViewChild('container', { static: true })
  container!: ElementRef<HTMLDivElement>;

  @Output() solved = new EventEmitter<string>();
  @Output() failed = new EventEmitter<string>();

  private readonly recaptchaService = inject(RecaptchaService);

  async ngAfterViewInit(): Promise<void> {
    try {
      const token = await this.recaptchaService.renderV2(this.container.nativeElement);
      this.solved.emit(token);
    } catch (err) {
      this.failed.emit(String(err));
    }
  }
}
